/* eslint-disable react/require-default-props */
import React from 'react';
import { useIntl } from 'react-intl';
import { FlexColumn, Select } from 'design-system';
import { getOptionId, getOptionLabel } from '../surveyPreviewUtils';

function mapOptions(options) {
  return (options || [])
    .map((option, index) => ({
      value: getOptionId(option, index),
      label: getOptionLabel(option),
    }))
    .filter((option) => option.label);
}

export default function DropdownOptions({
  options = [],
  preview = false,
  value,
  onChange,
  interactive = false,
  hasError = false,
}) {
  const intl = useIntl();
  const selectOptions = mapOptions(options);
  const placeholder = `${intl.formatMessage({ id: 'select' })}...`;

  if (!selectOptions.length) {
    return null;
  }

  return (
    <FlexColumn align="stretch" fullWidth className={preview ? 'cc-preview-dropdown' : 'mt-2'}>
      <Select
        block
        disabled={!interactive}
        options={selectOptions}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        error={hasError}
        className={preview ? 'cc-preview-dropdown__field' : ''}
      />
    </FlexColumn>
  );
}
